// extracted by mini-css-extract-plugin
export var calendarView = "_mo-0";